import { golfEnums } from "../enums/golfEnums"
import { _matchPlayPercs } from "./calcMatchStatus"

export const getCourseHandicapIndex = (hcpIndex, rating, slope, par) => {
  const _calculatedHcp = (hcpIndex * (slope / 113)) + (rating - par)
  const courseHandicap = Math.round(_calculatedHcp)
  const courseHandicapIndex = _calculatedHcp.toFixed(1)
  return { courseHandicap, courseHandicapIndex }
}

/**
 * 
 * @param {object} golfer 
 * @param {string} golfCourseKey 
 * @param {object} tournamentGolfCourses 
 * @returns the Course Handicap for the golfer
 */
export const geGCGHandicapIndex = (calculateHcp, golfer, golfCourseKey, tournamentGolfCourses, _hci, _ctb, golfRoundKey) => {

  const { firstName, lastName, tournamentHandicapIndex, courseHandicap, courseHandicapIndexes, courseHandicaps, courseTeeboxes } = golfer ?? {}

  const _golfCourse = tournamentGolfCourses ? tournamentGolfCourses[golfCourseKey] : {}

  let _courseHandicap;
  let _courseHandicapIndex;

  if (_hci) {
    _courseHandicap = _hci
  } else {
    if (courseHandicaps && golfCourseKey && courseHandicaps[golfCourseKey]) {
      _courseHandicap = courseHandicaps[golfCourseKey]
    } else {
      _courseHandicap = courseHandicap
    }
    if (courseHandicapIndexes && golfCourseKey && courseHandicapIndexes[golfCourseKey]) {
      _courseHandicapIndex = courseHandicapIndexes[golfCourseKey]
    } else {
      _courseHandicapIndex = courseHandicap
    }
  }

  if (calculateHcp) {
    let _courseTeebox;

    if (_ctb) {
      _courseTeebox = _ctb
    } else {
      if (courseTeeboxes && golfCourseKey && courseTeeboxes[golfCourseKey]) {
        _courseTeebox = courseTeeboxes[golfCourseKey]
      } else {
        _courseTeebox = courseHandicap
      }
    }

    const { teeBoxes, holes } = _golfCourse ? _golfCourse : {}
    const _teebox = teeBoxes ? teeBoxes[_courseTeebox] : {}
    const { slope, rating } = _teebox ? _teebox : {}
    const par = getPar(holes)
    const { courseHandicap: ch, courseHandicapIndex: chi } = getCourseHandicapIndex(tournamentHandicapIndex, rating, slope, par)

    let _chr;

    switch (golfRoundKey) {
      case golfEnums.roundTypes.bestBall:
        _chr = (_courseHandicapIndex * _matchPlayPercs.bestBall).toFixed(1)
        break;
      default:
        _chr = _courseHandicapIndex
    }

    const { courseHandicap: ch1, courseHandicapIndex: chi1 } = getCourseHandicapIndex(_chr, rating, slope, par)

    const p = {
      name: firstName + ' ' + lastName,
      golfRoundKey,
      tournamentHandicapIndex,
      courseHandicap: _courseHandicap,
      courseHandicapIndex: _courseHandicapIndex,
      courseHandicap_normal: _courseHandicap,
      courseHandicap_chi: ch1,
      courseHandicap_thi: ch,
      courseHandicap_thibb: Math.round(_courseHandicap * _matchPlayPercs.bestBall),
      _chr: _chr,
    }

    if (p.courseHandicap_thibb !== p.courseHandicap_chi) {
      console.log('Round Hcp', p)
    }
    return { courseHandicap: ch, courseHandicapIndex: chi }
  } else {
    return { courseHandicap: _courseHandicap, courseHandicapIndex: _courseHandicapIndex }
  }
}

export const getHandicapIndexFromCourse = (courseHandicap, rating, slope, par) => {
  let hcpIndex = (courseHandicap / (slope / 113)) - (rating - par)
  hcpIndex = Math.round(hcpIndex)
  return hcpIndex
}

export const getPar = (holes) => {
  let _par = 0
  if (holes) {
    Object.keys(holes).forEach(hKey => {
      _par += parseInt(holes[hKey].par)
    })
  }
  return _par
} 